import { render } from "./BarcodePrint.vue?vue&type=template&id=6891fe56&scoped=true"
import script from "./BarcodePrint.vue?vue&type=script&lang=js"
export * from "./BarcodePrint.vue?vue&type=script&lang=js"

import "./BarcodePrint.vue?vue&type=style&index=0&id=6891fe56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6891fe56"]])

export default __exports__